import { Text } from '@cleartax/wg-library-typography';
import { forwardRef } from 'react';
import { usePlanCtx } from '../../../planDetailsContext';
import { SectionConatiner } from '../../ui-blocks/containers';
import { SectionHeading } from '../../ui-blocks/typograpghy';
import { ISection } from '../types';

export const AboutSection: React.FC<ISection> = forwardRef(
  ({ id, name }, ref: React.ForwardedRef<HTMLDivElement>) => {
    const planDetails = usePlanCtx();

    return (
      <div id={id} ref={ref}>
        <SectionConatiner>
          <SectionHeading>{name}</SectionHeading>
          <Text type="p" className="text-brand-1000 pt-6" weight="medium">
            {planDetails.longDescription}
          </Text>
        </SectionConatiner>
      </div>
    );
  }
);
